export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBmC_eXq8nCsWmDgF_S3hzPQAdFGFQncCQ',
    authDomain: 'prod-6a983.firebaseapp.com',
    databaseURL: 'https://prod-6a983.firebaseio.com',
    projectId: 'prod-6a983',
    storageBucket: 'prod-6a983.firebasestorage.app',
    messagingSenderId: '547952659074',
    appId: '1:547952659074:web:3b43fb27a1938267d9429b',
    measurementId: 'G-K3MHRGYWE6',
  },
};
